/** Copyright 2026 Midas Healthcare Solutions - All Rights Reserved **/
import { DestroyRef, Directive, inject } from '@angular/core';
import { NgxMatDatetimepicker } from '@ngxmc/datetime-picker';

@Directive({
  selector: 'ngx-mat-datetime-picker[midasEndDateDefaults]',
  standalone: true,
})
export class EndDateDefaultsDirective {
  constructor() {
    const picker = inject<NgxMatDatetimepicker<Date>>(NgxMatDatetimepicker);
    const destroyRef = inject(DestroyRef);
    const registerInput = picker.registerInput;

    picker.registerInput = (input) => {
      const model = registerInput.call(picker, input);
      const add = model.add;
      model.add = (date) => {
        if (date && !model.selection) {
          date = new Date(date);
          date.setHours(23, 59, 59, 0);
        }
        add.call(model, date);
      };
      destroyRef.onDestroy(() => { model.add = add; });
      return model;
    };
    destroyRef.onDestroy(() => { picker.registerInput = registerInput; });
  }
}
